import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import pexels from '../util/pexels'
import { updateStatus } from '../root/actions'
import { RESULTS_FOUND } from '../root/constants'

const topicCall = async ({ query, page = 1 }, { dispatch }) => {
  const response = await pexels.topics.getPhotos({
    topicIdOrSlug: query,
    page,
    perPage: 12,
    orientation: 'landscape',
    sort: 'desc'
  })
  dispatch(
    updateStatus(RESULTS_FOUND(response.response.total_results, query, page))
  )

  return response.response
}

export const getByTopicFirstCall = createAsyncThunk(
  'home/getByTopicFirstCall',
  topicCall
)

export const getByTopic = createAsyncThunk('home/getByTopic', topicCall)

export const setTopic = createAction('home/setTopic', (category) => ({
  payload: category,
}));
